export default (inputDate: string | Date, isDatePickerValue: boolean = false): Date => {
  let date: Date;

  if (typeof inputDate === "string") {
    date = new Date(`${inputDate}T00:00:00Z`);
    const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  
    return utcDate;
  } else if (inputDate instanceof Date) {
    date = inputDate;
  } else {
    throw new Error("Invalid date format");
  }

  if (isDatePickerValue) {
    const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

    return utcDate;
  } else {
    const utcDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    return utcDate;
  }
}